import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import MobileView from '../../../../MobileFinancialPlan/MobileInsurance/MobileLife/MobileProgressChart/MobileProgressChartView';
import { selectedIndex as selectedOwnerIndex } from '../../OwnerDropdown/OwnerDropdownSelector';
import {
  selectedIndex as selectedTabIndex,
  selectedTabId,
} from '../../SplitTabs/SplitTabsSelector';
import { chartDataSelector } from './ProgressChartSelector';
import View from './ProgressChartView';

const mapStateToProps = (state, ownProps) => {
  const chartData = chartDataSelector(state, ownProps);
  const ownerIndex = !isNil(ownProps.ownerIndex)
    ? ownProps.ownerIndex
    : selectedOwnerIndex(state, ownProps);
  const breakdown =
    ownerIndex === 0
      ? ownProps.subgoalData.BreakdownPrincipal
      : ownProps.subgoalData.BreakdownSpouse;

  return {
    breakdown,
    ownerIndex,
    tabIndex: !isNil(ownProps.tabId) ? ownProps.tabId : selectedTabIndex(state, ownProps),
    tabId: !isNil(ownProps.tabId) ? ownProps.tabId : selectedTabId(state, ownProps),
    chartData,
    hasChartData: !!chartData,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileProgressChart = connect(mapStateToProps, mapDispatchToProps)(MobileView);
